"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonTranscodable = exports.isMetadataFile = exports.safeGetNameTypeAndExt = exports.getNameTypeAndExt = exports.getClipTypeFromExt = exports.isPdf = exports.isRawPhoto = exports.isDocument = exports.isAnimatedType = exports.isVideoType = exports.isPhotoType = exports.isAudioType = exports.getName = exports.getExt = exports.FALLBACK_NAME = exports.FALLBACK_EXT = void 0;
const types_1 = require("@air/types");
const path_1 = require("path");
const exts_1 = require("./exts");
exports.FALLBACK_EXT = 'file';
exports.FALLBACK_NAME = '_untitled';
const DEFAULT_TYPE = types_1.ClipType.nonMedia;
const pathHasExt = (path) => (0, path_1.extname)(path) !== '';
const getExt = (pathOrExt) => {
    if (!pathOrExt) {
        throw new Error("Can't getExt on a falsy path");
    }
    return pathOrExt.split('.').pop();
};
exports.getExt = getExt;
const getName = (path) => {
    if (!path) {
        throw new Error("Can't getName on a falsy path");
    }
    return (0, path_1.basename)(path, (0, path_1.extname)(path));
};
exports.getName = getName;
const isType = (type) => (pathOrExt) => {
    if (!pathOrExt) {
        return false;
    }
    const { type: extType } = (0, exts_1.getExtData)((0, exports.getExt)(pathOrExt));
    return extType === type;
};
const isKind = (kind) => (pathOrExt) => {
    if (!pathOrExt) {
        return false;
    }
    const { kind: extKind } = (0, exts_1.getExtData)((0, exports.getExt)(pathOrExt));
    return extKind === kind;
};
exports.isAudioType = isType(types_1.ClipType.audio);
exports.isPhotoType = isType(types_1.ClipType.photo);
exports.isVideoType = isType(types_1.ClipType.video);
exports.isAnimatedType = isType(types_1.ClipType.animated);
const isDocument = (pathOrExt) => isKind('document')(pathOrExt) || isKind('presentation')(pathOrExt);
exports.isDocument = isDocument;
exports.isRawPhoto = isKind('rawImage');
const isPdf = (pathOrExt) => isKind('document')(pathOrExt) && (0, exports.getExt)(pathOrExt) === 'pdf';
exports.isPdf = isPdf;
const extTypes = [
    { check: exports.isPhotoType, extType: types_1.ClipType.photo },
    { check: exports.isAnimatedType, extType: types_1.ClipType.animated },
    { check: exports.isVideoType, extType: types_1.ClipType.video },
    { check: exports.isAudioType, extType: types_1.ClipType.audio },
];
const getClipTypeFromExt = (ext, importedName) => {
    const foundExtType = extTypes.find(({ check }) => check(ext));
    const isMetaDataFile = importedName && hasLeadingPeriod(importedName);
    return foundExtType && !isMetaDataFile ? foundExtType.extType : DEFAULT_TYPE;
};
exports.getClipTypeFromExt = getClipTypeFromExt;
const getNameTypeAndExt = (path) => {
    if (!path || !path.includes('.')) {
        throw new Error(`Invalid path for getNameTypeAndExt: ${path}`);
    }
    const importedName = (0, exports.getName)(path);
    const ext = (0, exports.getExt)(path);
    const type = (0, exports.getClipTypeFromExt)(ext, importedName);
    return { ext, type, importedName };
};
exports.getNameTypeAndExt = getNameTypeAndExt;
const safeGetNameTypeAndExt = (path) => {
    try {
        return (0, exports.getNameTypeAndExt)(path);
    }
    catch (error) {
        console.log(`Invalid path name detected pathName: ${path}; falling back to .${exports.FALLBACK_EXT} extension`);
        return {
            ext: exports.FALLBACK_EXT,
            type: types_1.ClipType.nonMedia,
            importedName: path === undefined ? exports.FALLBACK_NAME : path,
        };
    }
};
exports.safeGetNameTypeAndExt = safeGetNameTypeAndExt;
const hasLeadingPeriod = (str) => str[0] === '.';
const isMetadataFile = (str) => hasLeadingPeriod(str) || !pathHasExt(str);
exports.isMetadataFile = isMetadataFile;
const isNonTranscodable = (ext) => !(0, exts_1.getExtData)(ext).transcodable;
exports.isNonTranscodable = isNonTranscodable;
//# sourceMappingURL=path.js.map